import { sharedFriendsService, DisplayNames } from 'Roblox';
import angular from 'angular';
import chatModule from '../chatModule';

function friendsController($scope, chatUtility, friendsInfoService, usersService) {
  'ngInject';

  $scope.dialogLayout.scrollToBottom = false;
  $scope.dialogLayout.IsdialogContainerVisible = false;
  $scope.dialogParams = { ...chatUtility.dialogParams };
  $scope.dialogType = { ...chatUtility.dialogType };
  $scope.userPresenceTypes = { ...chatUtility.userPresenceTypes };
  $scope.friendsScrollbarElm = chatUtility.getScrollBarSelector(
    $scope.dialogData,
    chatUtility.scrollBarType.FRIENDSELECTION
  );
  $scope.dialogData.scrollBarType = chatUtility.scrollBarType.FRIENDSELECTION;

  $scope.dialogData.isCreated = true;

  $scope.updateFriendsDictData = function(friends) {
    const userIds = [];
    angular.forEach(friends, function(friend, userId) {
      const currentFriend = friend;
      currentFriend.id = parseInt(userId);
      const { name, displayName } = currentFriend;
      currentFriend.nameForDisplay = DisplayNames?.Enabled() ? displayName : name;

      if (!$scope.chatLibrary.friendsDict[userId]) {
        $scope.chatLibrary.friendsDict[userId] = currentFriend;
        userIds.push(userId);
      }
    });
    $scope.updateFriends(friends);
    if (userIds && userIds.length > 0) {
      usersService.getAvatarHeadshots(userIds, $scope.chatLibrary.friendsDict);
    }
  };

  const getFriends = function() {
    const cacheCriteria = {
      isEnabled: $scope.chatLibrary.isUsingCacheToLoadFriendsInfoEnabled,
      expirationMS: $scope.chatLibrary.cachedDataFromLocalStorageExpirationMS
    };
    sharedFriendsService.register($scope.updateFriendsDictData, cacheCriteria);
  };

  if ($scope.chatLibrary.friendIds.length > 0) {
    $scope.updateFriends();
  }
  getFriends();
  $scope.isOverLoaded();
}

chatModule.controller('friendsController', friendsController);

export default friendsController;
